import { P2GBox, P2GGrid, SvgAdd } from '@parcel2go/core-ui';
import { DashDateSelection } from '../../dash/DashDateSelection';

import CdnIconProxy from '~/apps/account-linking/components/CdnIconProxy';
import Add from '../filter/Add';
import { MobileButtonBox } from '../filter/MobileButtonBox';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

interface props {
  period: string;
  selected: string;
  setPeriod: (period: string) => void;
  children?: React.ReactNode;
}

const ListyFilterBarMobile: React.FC<props> = (props) => {
  const { t } = useTranslation(TranslationNamespaces.MYORDERS);

  const setPeriod = (p: string) => {
    props.setPeriod(p);
  };

  return (
    <>
      <P2GGrid container justify="center" gap={1} wrap="nowrap" alignItems="center">
        <P2GGrid item flexGrow={1}>
          <DashDateSelection
            period={props.period}
            setPeriod={setPeriod}
            label={t('MY_ORDERS_DATE_RATE_LABEL', 'Date Range')}
          />
        </P2GGrid>

        <P2GGrid item>
          <Add>
            <MobileButtonBox>
              <CdnIconProxy src="/theme/icons/Add.svg" size="sm" palette="primary">
                <SvgAdd />
              </CdnIconProxy>
            </MobileButtonBox>
          </Add>
        </P2GGrid>
      </P2GGrid>
      <P2GBox py={2}>{props.children}</P2GBox>
    </>
  );
};

export default ListyFilterBarMobile;
